<template>
  <div class="switcher">
    <button
      v-click-outside="closeDropdown"
      class="dropdown-toggle uppercase"
      aria-label="toggle dropdown"
      @click="toggleDropdown"
    >
      {{ activeItem }}
      <icon-chevron-black class="mx-3" />
    </button>
    <div v-if="isOpen" class="dropdown-menu mt-3">
      <div
        v-for="item in list"
        :key="item.code"
        class="menu-item"
        :class="{
          active: item.code === activeItem,
          'lg:!text-center': isCentered,
        }"
        @click="changeActiveItem(item.code)"
      >
        {{ `${showCode ? item.code + " | " : ""}` + item.name }}
        <icon-check />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";
import type { PropType } from "vue";

interface DropdownData {
  name: string;
  code: string;
  id: number;
}

const emit = defineEmits(["update:activeItem"]);
const localePath = useLocalePath();
const props = defineProps({
  list: { type: Array as PropType<DropdownData[] | any[]>, required: true },
  isCentered: { type: Boolean, default: false },
  showCode: { type: Boolean, default: true },
  activeItem: { type: String, default: "" },
  routePath: { type: String, default: "/" },
  headerData: {
    type: Object,
    default: () => {
      return {};
    },
  },
});

const isOpen = ref(false);
const changeActiveItem = (code) => {
  emit("update:activeItem", code);
};
const toggleDropdown = () => {
  isOpen.value = !isOpen.value;
};
const closeDropdown = () => {
  isOpen.value = false;
};
</script>
